var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M47.5 14.4001C47.5 14.4001 47 11.1001 45.6 9.6001C43.8 7.7001 41.7 7.7001 40.8 7.6001C34.1 7.1001 24 7.1001 24 7.1001C24 7.1001 13.9 7.1001 7.2 7.6001C6.3 7.7001 4.2 7.7001 2.4 9.6001C1 11.1001 0.5 14.4001 0.5 14.4001C0.5 14.4001 0 18.3001 0 22.2001V25.8001C0 29.7001 0.5 33.6001 0.5 33.6001C0.5 33.6001 1 36.9001 2.4 38.4001C4.2 40.3001 6.6 40.3001 7.7 40.5001C11.5 40.9001 24 41.0001 24 41.0001C24 41.0001 34.1 41.0001 40.8 40.5001C41.7 40.4001 43.8 40.4001 45.6 38.5001C47 37.0001 47.5 33.7001 47.5 33.7001C47.5 33.7001 48 29.8001 48 25.9001V22.3001C48 18.3001 47.5 14.4001 47.5 14.4001ZM19 30.2001V16.7001L32 23.5001L19 30.2001Z","fill":"white"}));
}

Youtube.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
